import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const HomeBase = (
  <path
    fill='currentColor'
    d='M11.98 4.093c-.119-.123-.309-.126-.43 0L2.52 13.44c-.119.123-.08.223.082.223h1.677c.164 0 .296.132.296.306v5.376c0 .361.283.654.65.654h4.916c.166 0 .3-.128.3-.308v-4.567c0-.17.142-.309.303-.309h2.041c.168 0 .304.128.304.309v4.567c0 .17.145.308.299.308h4.916c.359 0 .65-.288.65-.654V13.97c0-.17.135-.306.297-.306h1.676c.164 0 .204-.097.082-.223L11.98 4.093z'
  />
)

export const Home = createIcon({
  displayName: 'Home',
  viewBox: '0 0 24 24',
  path: HomeBase,
})
